export const PATTERNS = {
    url: /(https?:\/\/|www\.)[\w#%+.:=@~-]{1,256}\.(xn--)?[\da-z-]{2,20}\b([\w#%&+,./:=?@[\]~-]*[\w#%&+/:=?@\]~-])*/gi,
    numbersOnly: /^\d+$/,
};
